import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Line } from 'react-chartjs-2'

import { ContainerChart } from '../ContainerChart/ContainerChart'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

const LineChart: React.FC = () => {
  const labels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July'
  ]
  return (
    <ContainerChart>
      <Line
        options={{
          plugins: {
            legend: {
              position: 'top' as const
            }
          },
          responsive: true
        }}
        data={{
          datasets: [
            {
              backgroundColor: 'rgba(255, 99, 132, 0.5)',
              borderColor: 'rgb(255, 99, 132)',
              data: [1000, 970, 860, 500, 970, 860, 100],
              label: 'SLA Carteira'
            },
            {
              backgroundColor: 'rgba(53, 162, 235, 0.5)',
              borderColor: 'rgb(53, 162, 235)',
              data: [890, 670, 360, 100, 890, 670, 360],
              label: 'SLA Pendencia'
            }
          ],
          labels
        }}
      />
    </ContainerChart>
  )
}

export default LineChart
